export default __webpack_public_path__ + "static/media/kintohub.019edd29.webp";